<template>
  <div class="announce-list">
    <a-table
        :columns="columns"
        :data-source="dataSource"
        :pagination="false"
        :loading="loading"
        rowKey="id"
        @change="handleTableChange">
    </a-table>
  </div>
</template>

<script>
import {getAction} from "@/api/manage";

export default {
  name: "AnnounceList",
  data() {
    return {
      dataSource: [],
      columns: [
        {
          title: '单位名称',
          dataIndex: 'oname',
          width: 350,
          ellipsis: true,
        },
        {
          title: '金额（元）',
          dataIndex: 'contractMoney',
          width: 700,
        },
        {
          title: '时间',
          dataIndex: 'uploadTime',
          ellipsis: true
        },
      ],
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '30', '50'],
        showTotal: (total, range) => {
          return "第" + range[0] + "至" + range[1] + "条,共" + total + "条"
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      loading: false,
      queryParam: {},
      isorter:{
        order: 'desc',
      },
      /* 筛选参数 */
      filters: {},
    }
  },
  created() {
    this.dataList()
  },
  methods: {
    searchQuery(){
      this.dataList(1);
    },
    searchReset() {
      this.queryParam = {}
      this.dataList();
    },
    getQueryParams() {
      //获取查询条件
      let sqp = {}
      var param = Object.assign(sqp, this.queryParam, this.isorter ,this.filters);
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return param;
    },
    getQueryField() {
      //TODO 字段权限控制
      var str = "id,";
      this.columns.forEach(function (value) {
        str += "," + value.dataIndex;
      });
      return str;
    },
    dataList(arg) {
      if (arg === 1) {
        this.ipagination.current = 1;
      }
      var param = this.getQueryParams();
      this.loading = true;
      getAction('/announce/pageList', param).then(res => {
        if (res.success) {
          this.loading = false;
          this.dataSource = res.data.records;
          this.ipagination.total = res.data.total;
        }
      })
    },
    handleTableChange(pagination, filters, sorter) {
      this.ipagination = pagination;
      this.dataList();
    },
  }
}
</script>

<style scoped>
.announce-list{
  width: 1200px;
  margin: 20px auto;
  background: #FFFFFF;
  min-height: calc(100vh - 500px);
}
</style>
